<template>
  <v-toolbar
    elevation="0"
    style="z-index: 2"
  >
    <v-toolbar-title>
      <div>
        <div class="d-flex align-center">
          <h2 v-if="isBaixa">Conciliando guia de baixa</h2>
          <h2 v-else>Conciliando guia - {{ pagamentoGuia.loading ? 'Carregando...' : numeroGuiaPrestador }} (Lote: {{ numeroLote || '-' }})</h2>
          <v-chip v-if="pagamentoGuia.status === 'conciliacaoAutomatica'" class="ml-4" small>Conciliando automaticamente</v-chip>
        </div>
        <div class="text-subtitle-1">Realize a conciliação de guias e itens de faturamento e pagamento</div>
      </div>
    </v-toolbar-title>

    <v-spacer />

    <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" color="primary" outlined>
          Ações
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          @click="item.action"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      menuItems: [
        { title: 'Conciliar guia automaticamente', action: this.handleConciliacaoAutomaticaClick } // TODO: Add call to conciliacao automatica
      ],
      limparConciliacaoItens: false
    }
  },
  computed: {
    ...mapState('conciliacao', [ 'pagamentoLoteId', 'pagamentoGuiaId', 'pagamentoGuia']),
    numeroGuiaPrestador () {
      return this.pagamentoGuia.result?.numeroGuiaPrestador
    },      
    numeroGuiaOperadora () {
      return this.pagamentoGuia.result?.numeroGuiaOperadora
    },    
    senha () {
      return this.pagamentoGuia.result?.senha
    },    
    pagamentoguiaLoading () {
      return this.pagamentoGuia.loading
    }, 
    numeroLote () {
      return this.pagamentoGuia.result?.pagamentoLote?.numeroLote
    },
    isBaixa () {
      return this.pagamentoGuia.result?.isBaixa
    }
  }, 
  methods: {
    handleConciliacaoAutomaticaClick () {
      const paramModal = {
        type: "warning",
        title: "Conciliar automaticamente guia",
        message: "Confirme a ação que deve ser feita na conciliação automática dos itens da guia.",
        callback: () => {
          this.limparConciliacaoItens = false
          this.conciliarAutomaticamente()
        },
        btConfirm: { name: "Manter itens conciliados", show: true },
        btExtra: {
          name: "Desconciliar itens",
          color: 'secondary',
          show: true,
          callback: () => {
            this.limparConciliacaoItens = true,
            this.conciliarAutomaticamente()
          }
        },
        btCancel: {
          name: "Cancelar",
          show: true,
        }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    async conciliarAutomaticamente () {
      const payload = {
        createCommand: {
          pagamentoLoteId: this.pagamentoLoteId,
          pagamentoGuiaId: this.pagamentoGuiaId,
          limparConciliacaoGuias: false,
          limparConciliacaoItens: this.limparConciliacaoItens,
          runOnCreation: true
        },
        modalParams: {
          type: 'error',
          title: 'Erro ao conciliar a guia automaticamente',
          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }
      }

      this.$store.dispatch('conciliacao/conciliarGuiaAutomaticamente', payload)
    }
  },
  watch: {
    pagamentoguiaLoading(novoValor, valorAntigo) {
    if (!novoValor) {
      if (!this.numeroGuiaPrestador && !this.numeroGuiaOperadora && !this.numeroLote && !this.senha){
         this.$router.go(-1);      
         console.log(valorAntigo,novoValor);
       }    
      } 
  }
}
}
</script>
